import { LuIcon, radiusCva, useProvider } from "@overmap-ai/blocks"
import { cx } from "class-variance-authority"
import { Circle } from "lucide-react"
import { type ComponentPropsWithRef, memo } from "react"
import { twMerge } from "tailwind-merge"

import { ThemePalettes } from "../../enums/theme"

interface ThemePaletteIconProps extends ComponentPropsWithRef<"div"> {
	themePalette: ThemePalettes
	inline?: boolean
}

export const ThemePaletteIcon = memo<ThemePaletteIconProps>((props) => {
	const { ref, themePalette, className, inline = false, ...rest } = props
	const { radius } = useProvider()

	return (
		<div
			ref={ref}
			className={twMerge(
				cx(
					"bg-(--color-background) ring-(--base-6) flex items-center gap-1 px-1 py-0.5 ring",
					radiusCva({ radius, maxLarge: true }),
					{
						"-m-1": inline,
					},
					className,
				),
			)}
			data-theme={themePalette}
			{...rest}
		>
			<LuIcon icon={Circle} size="8px" color="var(--primary-9)" fill="var(--primary-9)" />
			<span className="text-(--base-11) text-xs">Aa</span>
		</div>
	)
})
ThemePaletteIcon.displayName = "ThemePaletteIcon"
